module.exports = __webpack_public_path__ + "node_modules/font-awesome/fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 161
// module chunks = 0